const HISTORY_KEY = 'comet_design_history';
const MAX_VERSIONS = 20;

function loadHistory(designId) {
  try {
    const all = JSON.parse(localStorage.getItem(HISTORY_KEY) || '{}');
    return all[designId] || [];
  } catch {
    return [];
  }
}

function saveHistory(designId, versions) {
  try {
    const all = JSON.parse(localStorage.getItem(HISTORY_KEY) || '{}');
    all[designId] = versions.slice(0, MAX_VERSIONS);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(all));
  } catch (_) {
    void 0;
  }
}

export function saveVersion(designId, design) {
  const versions = loadHistory(designId);
  const version = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    name: design.name,
    nodes: design.nodes,
    edges: design.edges,
    savedAt: new Date().toISOString(),
    nodeCount: design.nodes?.length || 0,
    edgeCount: design.edges?.length || 0,
  };
  versions.unshift(version);
  saveHistory(designId, versions);
  return version;
}

export function getVersions(designId) {
  return loadHistory(designId);
}

export function deleteVersion(designId, versionId) {
  const versions = loadHistory(designId);
  const updated = versions.filter((v) => v.id !== versionId);
  saveHistory(designId, updated);
  return updated;
}

export function clearHistory(designId) {
  saveHistory(designId, []);
}

export function getVersion(designId, versionId) {
  const versions = loadHistory(designId);
  return versions.find((v) => v.id === versionId) || null;
}
